import React, { Component, ErrorInfo } from 'react';
import * as Sentry from '@sentry/react';
import i18n from '@i18n/index';

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<React.PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureReactException(error, info);
    console.error('Customer portal render error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-white px-6 text-center">
          <div className="max-w-[420px]">
            <h1 className="mb-2 text-[20px] font-bold text-[#111827]">
              {i18n.t('errorBoundary.title')}
            </h1>
            <p className="mb-6 text-[14px] text-[#6B7280]">{i18n.t('errorBoundary.body')}</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="w-full rounded bg-[#2563EB] py-3 text-[14px] font-medium text-white transition-opacity hover:opacity-90"
            >
              {i18n.t('errorBoundary.reload')}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
